module.exports = __webpack_public_path__ + "img/motor_grader.517314ec.png";